import { labelPhotoPath } from '../domain/label-photos';
import type { PhotoStorage } from '../store/fake-storage';

/**
 * Keeping a label photo (owner request, 2026-10-11): the JPEG the scan already shrank (base64,
 * at most 1500 pixels a side, a few hundred KB) is stored under a new name next to the cellar,
 * and that name is what the wine keeps.
 */
export async function keepPhoto(
  photos: PhotoStorage,
  cellarId: string,
  base64Jpeg: string,
): Promise<string> {
  const id = crypto.randomUUID();
  await photos.put(labelPhotoPath(cellarId, id), base64ToBytes(base64Jpeg));
  return id;
}

export function base64ToBytes(base64: string): Uint8Array {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}
